// extracted by mini-css-extract-plugin
export default {"tab":"bank-accounts_tab__9XFsU"};